// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { getBaseUrl, getPrepareHeaders } from './config';

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, WebApi, extraOptions) => {
  const baseUrl = getBaseUrl();
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: getPrepareHeaders(),
  });
  return rawBaseQuery(args, WebApi, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const mehirApi = createApi({
  baseQuery: dynamicBaseQuery,
  tagTypes: [
    // Campaign service
    'Campaigns',
    'FavoriteCampaigns',
    'CampaignCategories',
    // Blog service
    'Blogs',
    'FavoriteBlogs',
    'BlogCategories',
    'Announcements',
    'Faqs',
    'FaqCategories',
    'ContactInfos',
    'AppContracts',
    // Calendar service
    'Memories',
    'Events',
    'Calendars',
    'Tags',
    // Contract service
    'Contract',
    'ManuelPayment',
    'InterimPayment',
    'PayPlan',
    'Transaction',
    'MainType',
    'SavingsPlan',
    'ContributionInfo',
    // Insurance / BES service
    'BesPolicy',
    'BesCustomer',
    'PaymentInstrument',
    'BesFunds',
    // Fit service
    'MedicineReminder',
    'Targets',
    'Levels',
    'ExerciseTypes',
    'Exercises',
    'UserExercise',
    'DailyStep',
    'DrinkActivity',
    'WaterConsumption',
    'WaterOptions',
    'ReminderNotification',
    'Pharmacies',
    'Hospitals',
    'FitVideos',
    // Finance service
    'EkstreAI',
    'Currencies',
    'Funds',
    'Metals',
    'FavoriteFunds',
    'FavoriteMetals',
    'FinanceCategories',
    // Auth service
    'User',
    'Addresses',
    'AddressData',
    'Devices',
    'NotificationPermissions',
    'CommunicationPermissions',
    'SupportRequests',
    'LoginHistory',
    'InvitedUsers',
    'AppVersion',
    'ServiceStatus',
    // Backoffice service
    'Roles',
    'RolePermissions',
  ],
  endpoints: () => ({}),
  // Memory-friendly cache settings:
  //   keepUnusedDataFor=30 → unsubscribed cache entries are evicted after 30s
  //   (default is 60). Was 300 — held big payloads (city list, blog feed,
  //   campaigns, currencies) in memory for 5 minutes after the last consumer
  //   unmounted, which inflated heap on long sessions.
  //   refetchOnMountOrArgChange stays at 300 because that only controls
  //   "should we refetch on remount" — it doesn't influence retention.
  keepUnusedDataFor: 30,
  refetchOnMountOrArgChange: 300,
  refetchOnFocus: false,
  refetchOnReconnect: true,
});
